
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as d2FzbTpqcy1zdHJpbmc from './Jiku-webApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;
let require;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    const module = await import(/* webpackIgnore: true */'node:module');
    const importMeta = import.meta;
    require = module.default.createRequire(importMeta.url);
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
    'kotlinx.coroutines.console_$external_prop_getter' : () => console,
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.FocusEvent_$external_class_instanceof' : (x) => x instanceof FocusEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_get' : () => FocusEvent,
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_instanceof' : (x) => x instanceof PointerEvent,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_get' : () => PointerEvent,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
    'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.xhr.open_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
    'org.w3c.xhr.send_$external_fun' : (_this, ) => _this.send(),
    'org.w3c.xhr.overrideMimeType_$external_fun' : (_this, p0) => _this.overrideMimeType(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
              case 'pointercancel':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.foundation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.foundation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.isInTestEnvironment' : () => window.composeResourcesTesting == true,
    'org.jetbrains.compose.resources.requestResponseAsByteArray' : (req) =>  {
            var text = req.responseText;
            var int8Arr = new Int8Array(text.length);
            for (var i = 0; i < text.length; i++) {
                int8Arr[i] = text.charCodeAt(i) & 0xFF;
            }
            return int8Arr;
        },
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.material3.internal.getFirstDayOfWeek' : (locale) => { try { 
               return new Intl.Locale(locale).weekInfo.firstDay; 
            } catch (error) { 
               return -1; 
          }},
    'androidx.compose.material3.internal.emptyLocaleOptions' : () => new Object(),
    'androidx.compose.material3.internal.Date_$external_fun' : (p0) => new Date(p0),
    'androidx.compose.material3.internal.Date_$external_fun_1' : (p0, p1, p2) => new Date(p0, p1, p2),
    'androidx.compose.material3.internal.getDay_$external_fun' : (_this, ) => _this.getDay(),
    'androidx.compose.material3.internal.toLocaleDateString_$external_fun' : (_this, p0, p1, isDefault0) => _this.toLocaleDateString(p0, isDefault0 ? undefined : p1, ),
    'androidx.compose.material3.internal.now_$external_fun' : (_this, ) => _this.now(),
    'androidx.compose.material3.internal.Companion_$external_object_getInstance' : () => Date,
    'androidx.compose.material3.internal.weekday_$external_prop_setter' : (_this, v) => _this.weekday = v,
    'androidx.compose.material3.internal.year_$external_prop_setter' : (_this, v) => _this.year = v,
    'androidx.compose.material3.internal.month_$external_prop_setter' : (_this, v) => _this.month = v,
    'androidx.compose.material3.internal.day_$external_prop_setter' : (_this, v) => _this.day = v,
    'androidx.compose.material3.internal.hour_$external_prop_setter' : (_this, v) => _this.hour = v,
    'androidx.compose.material3.internal.minute_$external_prop_setter' : (_this, v) => _this.minute = v,
    'androidx.compose.material3.internal.second_$external_prop_setter' : (_this, v) => _this.second = v,
    'androidx.compose.material3.internal.Date_$external_class_instanceof' : (x) => x instanceof Date,
    'androidx.compose.material3.internal.Date_$external_class_get' : () => Date,
    'dev.rdd.jiku.fetchText' : (url, requestId, timeoutMs) => 
        (new Promise(function(resolve, reject) {
            window.__jikuFetchControllers = window.__jikuFetchControllers || {};
            var controller = new AbortController();
            window.__jikuFetchControllers[requestId] = controller;
            var timer = setTimeout(function() { controller.abort(); }, timeoutMs);
            function cleanup() {
                clearTimeout(timer);
                delete window.__jikuFetchControllers[requestId];
            }
            fetch(url, { signal: controller.signal }).then(function(r) {
                if (!r.ok) throw new Error('HTTP ' + r.status);
                return r.text();
            }).then(function(result) {
                cleanup();
                resolve(result);
            }).catch(function(e) {
                cleanup();
                reject(e);
            });
        }))
        ,
    'dev.rdd.jiku.renderBookPagePromise' : (backendUrl, sessionToken, bookTitle, pageLabel, backgroundImageId, backgroundBlur, itemsJson) => 
        (new Promise(function(resolve, reject) {
            var items = JSON.parse(itemsJson);
            var canvas = document.createElement('canvas');
            canvas.width = 1080;
            canvas.height = 1920;
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            // 1文字ずつ幅を測って詰める、英数字の単語境界を無視した折り返し(wrapByCharの実体)。
            // 日本語のように空白で単語が区切られない文字列は、下のwrapLinesがトークンをそのまま
            // 1つの塊としてこの関数に渡してくるため、最終的な折り返しはここで行われる
            function wrapByChar(text, maxWidth) {
                var lines = [];
                var current = '';
                for (var i = 0; i < text.length; i++) {
                    var ch = text.charAt(i);
                    var next = current + ch;
                    if (current.length > 0 && ctx.measureText(next).width > maxWidth) {
                        lines.push(current);
                        current = ch;
                    } else {
                        current = next;
                    }
                }
                lines.push(current);
                return lines;
            }

            // レビュー指摘(yamada-michel27、PR #350): 以前は文字種を問わず常に1文字ずつ詰めていたため、
            // "Hello wonderful world"のような英語の文章がAndroid(StaticLayout)・プレビュー(Compose
            // Text)とは違う位置(単語の途中)で折り返っていた。Android/プレビューはどちらも単語境界で
            // 折り返すため、ここも同じ規則にする: 空白区切りのトークン単位で詰め、1トークンだけで
            // maxWidthを超える場合(日本語のように空白で区切られない文字列を含む)だけwrapByCharへ
            // フォールバックする。改行(\n)は段落の区切りとして従来どおり扱う
            function wrapLines(text, maxWidth) {
                var lines = [];
                text.split('\n').forEach(function(paragraph) {
                    var current = '';
                    paragraph.split(' ').forEach(function(word) {
                        while (true) {
                            var candidate = current.length > 0 ? current + ' ' + word : word;
                            if (ctx.measureText(candidate).width <= maxWidth) {
                                current = candidate;
                                break;
                            }
                            if (current.length > 0) {
                                // 今の行に足すと溢れる場合、まず今の行を確定させてから
                                // 同じ単語を空の行に対して再度試す
                                lines.push(current);
                                current = '';
                                continue;
                            }
                            // 行が空なのに単語1つだけでmaxWidthを超える場合だけ文字単位に分解し、
                            // 最後の断片を次の単語に続けられるようcurrentに残す
                            var chunks = wrapByChar(word, maxWidth);
                            for (var i = 0; i < chunks.length - 1; i++) lines.push(chunks[i]);
                            current = chunks[chunks.length - 1];
                            break;
                        }
                    });
                    lines.push(current);
                });
                return lines;
            }

            // "#RRGGBB"の形をしていなければ既定色(黒。BookPageCanvas.ktのDefaultBookPageTextColorと
            // 同じ)に落とす。BookModels.ktのtextColor/textBackgroundColorのコメントどおり、
            // 色を持たない古いデータ・壊れた値をここで同じ扱いにする
            function resolveHexColor(hex) {
                return (typeof hex === 'string' && /^#[0-9a-fA-F]{6}$/.test(hex)) ? hex : '#000000';
            }

            // resolveHexColor済みの"#RRGGBB"にalpha(0..1)を掛けたrgba()文字列にする
            // (LIGHT見た目、BookPageTextStyle.applyToのColor.copy(alpha=0.65f)と同じ)
            function hexToRgba(hex, alpha) {
                var r = parseInt(hex.substr(1, 2), 16);
                var g = parseInt(hex.substr(3, 2), 16);
                var b = parseInt(hex.substr(5, 2), 16);
                return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
            }

            function loadImageUrl(url) {
                return fetch(url, {
                    headers: { 'Authorization': 'Bearer ' + sessionToken }
                }).then(function(response) {
                    if (!response.ok) throw new Error('HTTP ' + response.status);
                    return response.blob();
                }).then(function(blob) {
                    if (window.createImageBitmap) return createImageBitmap(blob);
                    return new Promise(function(resolveImage, rejectImage) {
                        var element = new Image();
                        var objectUrl = URL.createObjectURL(blob);
                        element.onload = function() { URL.revokeObjectURL(objectUrl); resolveImage(element); };
                        element.onerror = function() { URL.revokeObjectURL(objectUrl); rejectImage(new Error('image load failed')); };
                        element.src = objectUrl;
                    });
                });
            }

            function loadImage(imageId) {
                return loadImageUrl(backendUrl + '/images/' + encodeURIComponent(imageId) + '/file');
            }

            function customStampReactionId(stampId) {
                var prefix = 'custom-reaction:';
                return (typeof stampId === 'string' && stampId.indexOf(prefix) === 0)
                    ? stampId.substring(prefix.length)
                    : null;
            }

            // items(RenderableBookItem)は既にKotlin側でzIndex順に並べ替え済み・座標もピクセル値に
            // 解決済みのため、ここでは配列のindexを写真の対応付けキーとして使うだけでよい
            // (item自体はidを持たないDTOのため。同じimageIdが複数アイテムにまたがっても、
            // アイテムごとに個別にロードするので競合しない)
            // 1枚の写真が取得・デコードできなくても、ページ全体の書き出しは続ける
            // (BookPageRenderer.android.ktのrunCatching(...).getOrNull()と同じ方針。削除済み画像や
            // 一時的な5xxで、Promise.all全体がrejectしてページごと書き出せなくなるのを防ぐ)。
            // 失敗した写真はnullのままにし、下のbitmapByIndexへは載せない(描画側は`if (!bitmap) return;`
            // で既にガード済み)
            var backgroundPromise = backgroundImageId ? loadImage(backgroundImageId).catch(function() { return null; }) : Promise.resolve(null);
            Promise.all([backgroundPromise, Promise.all(items.map(function(item, index) {
                if (item.type !== 'PHOTO' || !item.imageId) return Promise.resolve(null);
                return loadImage(item.imageId).then(function(bitmap) {
                    return { index: index, bitmap: bitmap };
                }).catch(function() {
                    return null;
                });
            })), Promise.all(items.map(function(item, index) {
                var reactionId = item.type === 'STAMP' ? customStampReactionId(item.stampId) : null;
                if (!reactionId) return Promise.resolve(null);
                return loadImageUrl(backendUrl + '/custom-reactions/' + encodeURIComponent(reactionId) + '/image').then(function(bitmap) {
                    return { index: index, bitmap: bitmap };
                }).catch(function() {
                    return null;
                });
            }))]).then(function(result) {
                var background = result[0];
                var loaded = result[1];
                var loadedCustomStamps = result[2];
                if (background) {
                    var backgroundScale = Math.max(canvas.width / background.width, canvas.height / background.height);
                    var backgroundWidth = background.width * backgroundScale;
                    var backgroundHeight = background.height * backgroundScale;
                    var blurPx = Math.max(0, Math.min(100, backgroundBlur || 0)) * 0.9;
                    ctx.save();
                    ctx.filter = blurPx > 0 ? 'blur(' + blurPx + 'px)' : 'none';
                    // ぼかしの端で白が見えないよう、ぼかし量ぶんだけ余裕を持たせて描く。
                    var bleed = blurPx * 2;
                    ctx.drawImage(background, (canvas.width - backgroundWidth) / 2 - bleed, (canvas.height - backgroundHeight) / 2 - bleed, backgroundWidth + bleed * 2, backgroundHeight + bleed * 2);
                    ctx.restore();
                    if (background.close) background.close();
                }
                var bitmapByIndex = {};
                loaded.forEach(function(entry) {
                    if (entry) bitmapByIndex[entry.index] = entry.bitmap;
                });
                var customStampByIndex = {};
                loadedCustomStamps.forEach(function(entry) {
                    if (entry) customStampByIndex[entry.index] = entry.bitmap;
                });

                items.forEach(function(item, index) {
                    var x = item.x;
                    var y = item.y;
                    var w = item.w;
                    var h = item.h;

                    // プレビュー(BookPageCanvas.kt)と同じく、各パーツの配置枠の中心を軸に
                    // 回してから描く。save/restoreで次のアイテムへ変換が漏れないようにする。
                    if (item.type === 'PHOTO' && !bitmapByIndex[index]) return;
                    ctx.save();
                    ctx.translate(x + w / 2, y + h / 2);
                    ctx.rotate((typeof item.rotation === 'number' ? item.rotation : 0) * Math.PI / 180);
                    ctx.translate(-(x + w / 2), -(y + h / 2));

                    if (item.type === 'PHOTO') {
                        var bitmap = bitmapByIndex[index];
                        var cropScale = (typeof item.photoCropScale === 'number') ? Math.max(1, Math.min(4, item.photoCropScale)) : 1;
                        var scale = Math.max(w / bitmap.width, h / bitmap.height) * cropScale;
                        var dw = bitmap.width * scale;
                        var dh = bitmap.height * scale;
                        // 0=左/上、0.5=中央、1=右/下。保存済みのトリミング位置をプレビュー・
                        // Android書き出しと同じ意味で適用する。
                        var cropX = (typeof item.photoCropX === 'number') ? Math.max(0, Math.min(1, item.photoCropX)) : 0.5;
                        var cropY = (typeof item.photoCropY === 'number') ? Math.max(0, Math.min(1, item.photoCropY)) : 0.5;
                        ctx.save();
                        ctx.beginPath();
                        ctx.rect(x, y, w, h);
                        ctx.clip();
                        var layoutBlur = (typeof item.layoutBlur === 'number') ? Math.max(0, Math.min(100, item.layoutBlur)) : 0;
                        ctx.filter = layoutBlur > 0 ? 'blur(' + (layoutBlur * 0.9) + 'px)' : 'none';
                        ctx.drawImage(bitmap, x + (w - dw) * cropX, y + (h - dh) * cropY, dw, dh);
                        ctx.restore();
                        if (bitmap.close) bitmap.close();
                    } else if (item.type === 'TEXT') {
                        // #362以降、TEXTは既定で背景を塗らない(BookPageCanvas.ktのBookPageTextItemと
                        // 同じ。textBackgroundColorが指定されているときだけ塗る。以前の固定グレー背景は
                        // 廃止した)
                        //
                        // レビュー指摘(yamada-michel27、PR #350): 以前はここが`if (item.textBackgroundColor)`
                        // というtruthy判定だったため、"red"のような"#RRGGBB"でない壊れた値でもブロックに
                        // 入り、resolveHexColorが既定値の'#000000'を返してアイテム枠全面が黒く塗られて
                        // いた(Android/プレビューは同じ状況で「不正なら塗らない」なので、Webだけ挙動が
                        // 逆になっていた)。テキスト色と同じ/^#[0-9a-fA-F]{6}$/で弾き、不正なら塗らない形に揃える
                        var text = item.text || '';
                        var validBackgroundColor = (typeof item.textBackgroundColor === 'string' && /^#[0-9a-fA-F]{6}$/.test(item.textBackgroundColor))
                            ? item.textBackgroundColor
                            : null;
                        // レビュー指摘(yamada-michel27、PR #350 追加ラウンド): 「空」の判定は
                        // Android([BookPageRenderer.android.kt]のtext.isBlank())・プレビュー
                        // (BookPageCanvas.ktのtext.isBlank())と揃え、空文字だけでなく空白のみの
                        // 文字列(" "等)も「空」に含める。以前はここが`!text`(空文字のみ)だったため、
                        // 空白1文字のテキストがAndroidだけ枠全面・Webはフィットした帯になる食い違いが
                        // あった([textBackgroundBounds]のKDoc参照。判定を変えるときは4箇所を同時に直すこと)
                        var isBlankText = text.trim() === '';

                        // セルフレビュー(#353との整合性確認、PR #350): text=""(空文字)+
                        // textBackgroundColorだけを持つアイテムは、ストーリー画像の出力(#353、
                        // StoryImageRenderer.ktのbandLineItems)が情報帯・ロゴ帯の背景として使っており、
                        // 「textBackgroundColorがあれば文字の有無に関わらず枠いっぱいに背景を描く」という
                        // #297時点からの挙動に依存している。以前はこの背景塗りを`if (text)`の中に
                        // 移してしまい、空文字だと背景ごと描かれなくなっていた(#353の帯が消える事故)。
                        // 文字が無い(=isBlankText)場合はここでアイテム枠(x, y, w, h)全面・角なしを塗り、
                        // 文字がある場合だけ下の`if (!isBlankText)`の中で実測にフィットした角丸の帯に切り替える
                        if (validBackgroundColor && isBlankText) {
                            ctx.fillStyle = validBackgroundColor;
                            ctx.fillRect(x, y, w, h);
                        }

                        if (!isBlankText) {
                            // textStyle([BookPageTextStyles]のid)による見た目の対応関係は
                            // BookPageRenderer.ktのrenderableTextStyleOfと対で保つこと
                            var textStyleId = item.textStyle;
                            var bold = textStyleId === 'STRONG' || textStyleId === 'NEON' || textStyleId === 'OUTLINE';
                            var lighter = textStyleId === 'LIGHT';
                            var glowing = textStyleId === 'NEON';
                            var outlined = textStyleId === 'OUTLINE';
                            var baseColor = resolveHexColor(item.textColor);

                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'middle';
                            // BookPageCanvas.ktのBookPageTextItemと同じ比率(BOOK_PAGE_TEXT_HEIGHT_RATIO/
                            // BOOK_PAGE_TEXT_LINE_HEIGHT_MULTIPLIER、BookPageRenderer.kt)を使う。
                            // 以前はここだけ独立した0.16/1.3で、プレビューと書き出しの文字の大きさが
                            // 2.6倍もズレていた実バグがあった
                            var fontSize = Math.max(14, Math.round(h * 0.42));
                            ctx.font = (bold ? 'bold ' : '') + fontSize + 'px sans-serif';
                            // wはtoPixelRectのmaxOf(1, ...)で1pxまで縮み得るため、w-16が負になり
                            // 全文字が1行ずつ折り返される事故を防ぐ(BookPageRenderer.android.ktの
                            // maxOf(1, rect.width - 16)と同じガード)
                            var lines = wrapLines(text, Math.max(1, w - 16));
                            var lineHeight = fontSize * 1.25;
                            var startY = y + h / 2 - (lines.length - 1) * lineHeight / 2;

                            // 塗る矩形は、実際の行の最大幅・行数ぶんの高さにBOOK_PAGE_TEXT_BG_PADDING_RATIO
                            // 由来の余白を足した矩形を、アイテム枠と中心を揃えて角丸で塗る(このブロックは
                            // text=""ではない=文字がある経路にだけ来るので、空文字の全面塗りとは分けてある。
                            // BookPageRenderer.android.ktのtextBackgroundBoundsと同じ式)
                            if (validBackgroundColor) {
                                var textWidth = lines.reduce(function(maxWidthSoFar, line) {
                                    return Math.max(maxWidthSoFar, ctx.measureText(line).width);
                                }, 0);
                                var textHeight = lineHeight * lines.length;
                                var paddingH = h * 0.12;
                                var paddingV = paddingH * 0.6;
                                var bgWidth = textWidth + paddingH * 2;
                                var bgHeight = textHeight + paddingV * 2;
                                var bgLeft = x + w / 2 - bgWidth / 2;
                                var bgTop = y + h / 2 - bgHeight / 2;
                                var radius = Math.min(h * 0.14, bgWidth / 2, bgHeight / 2);
                                ctx.fillStyle = validBackgroundColor;
                                ctx.beginPath();
                                ctx.moveTo(bgLeft + radius, bgTop);
                                ctx.lineTo(bgLeft + bgWidth - radius, bgTop);
                                ctx.arcTo(bgLeft + bgWidth, bgTop, bgLeft + bgWidth, bgTop + radius, radius);
                                ctx.lineTo(bgLeft + bgWidth, bgTop + bgHeight - radius);
                                ctx.arcTo(bgLeft + bgWidth, bgTop + bgHeight, bgLeft + bgWidth - radius, bgTop + bgHeight, radius);
                                ctx.lineTo(bgLeft + radius, bgTop + bgHeight);
                                ctx.arcTo(bgLeft, bgTop + bgHeight, bgLeft, bgTop + bgHeight - radius, radius);
                                ctx.lineTo(bgLeft, bgTop + radius);
                                ctx.arcTo(bgLeft, bgTop, bgLeft + radius, bgTop, radius);
                                ctx.closePath();
                                ctx.fill();
                            }

                            // 「ひかる」は文字色そのものをぼかして後ろに敷く(BookPageCanvas.ktのShadow)。
                            // ぼかし量はBOOK_PAGE_TEXT_GLOW_RATIO(BookPageRenderer.kt)を参照する。
                            // 以前はここだけ独立した0.12という数値だった(値自体はズレていなかったが、
                            // 参照ではなく複製だったため変え忘れの余地が残っていた)
                            if (glowing) {
                                ctx.shadowColor = baseColor;
                                ctx.shadowBlur = h * 0.12;
                            }

                            // 「ふちどり」は、白い縁取りを先に描き、その上に本体を重ねて作る
                            // (BookPageCanvas.ktが2つのTextを重ねているのと同じ考え方)
                            if (outlined) {
                                // レビュー指摘(yamada-michel27、PR #350): 以前はここだけ独立した0.06で、
                                // BookPageCanvas.ktのBOOK_PAGE_TEXT_OUTLINE_RATIO(0.03)の2倍の太さで
                                // 書き出されていた。共通定数を参照する形にして再発を防ぐ
                                ctx.lineWidth = h * 0.03;
                                ctx.strokeStyle = '#ffffff';
                                lines.forEach(function(line, lineIndex) {
                                    ctx.strokeText(line, x + w / 2, startY + lineIndex * lineHeight);
                                });
                            }

                            // 「ほそめ」は太さではなく色を薄める(BookPageTextStyle.applyToと同じ)
                            ctx.fillStyle = lighter ? hexToRgba(baseColor, 0.65) : baseColor;
                            lines.forEach(function(line, lineIndex) {
                                ctx.fillText(line, x + w / 2, startY + lineIndex * lineHeight);
                            });

                            if (glowing) ctx.shadowBlur = 0;
                        }
                    } else if (item.type === 'STAMP') {
                        var customStamp = customStampByIndex[index];
                        if (customStamp) {
                            var customStampScale = Math.min(w / customStamp.width, h / customStamp.height);
                            var customStampWidth = customStamp.width * customStampScale;
                            var customStampHeight = customStamp.height * customStampScale;
                            ctx.drawImage(
                                customStamp,
                                x + (w - customStampWidth) / 2,
                                y + (h - customStampHeight) / 2,
                                customStampWidth,
                                customStampHeight,
                            );
                            if (customStamp.close) customStamp.close();
                        } else {
                        // stampId(RenderableBookItem)はKotlin側のtoRenderableBookItemsで、
                        // #347のBOOK_STAMPS(BookStamps.kt)のidから対応する絵文字にすでに解決済み
                        // (StampArtのスプライト画像そのものは書き出し側では再現しない。Issue #297の
                        // MVPスコープ外)
                        //
                        // fillStyleを明示しないと直前の描画(PHOTOの背景塗り'#ffffff'など)を
                        // 引き継ぐ。カラー絵文字フォントが無い環境ではモノクロ絵文字にフォールバック
                        // するため、白地に白でスタンプが消えてしまう。TEXTと同じ#1c1c1eで明示する
                        // (レビュー指摘 kigawa01、PR #350 中2: 以前はBookPageRenderer.android.ktが
                        // #000000で実値がズレていた。今は#1C1C1Eに揃えてある。色を変える場合は
                        // .android.ktのdrawStampItem・このファイルと.js.ktの3箇所を揃えて変更すること)
                        ctx.fillStyle = '#1c1c1e';
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'middle';
                        var stampSize = Math.max(16, Math.round(Math.min(w, h) * 0.8));
                        ctx.font = stampSize + 'px sans-serif';
                        ctx.fillText(item.stampId || '', x + w / 2, y + h / 2);
                        }
                    }
                    ctx.restore();
                });

                canvas.toBlob(function(blob) {
                    if (!blob) { reject(new Error('JPEGの生成に失敗しました')); return; }
                    var safeName = ((bookTitle || 'book') + '-' + (pageLabel || 'page')).replace(/[\\\\/:*?"<>|]/g, '_') + '.jpg';

                    // 「保存」操作では共有シートを優先せず、対応ブラウザでは必ずダウンロードを開始する。
                    // Web Share APIは共有先を選ぶ操作であり、端末へ保存されたことを意味しないため、
                    // 保存済みと表示する根拠にはできない。
                    function saveViaDownloadOrOpen() {
                        var link = document.createElement('a');
                        var isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
                            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
                        if ('download' in link && !isIos) {
                            var objectUrl = URL.createObjectURL(blob);
                            link.href = objectUrl;
                            link.download = safeName;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            setTimeout(function() { URL.revokeObjectURL(objectUrl); }, 1000);
                            resolve('download-started');
                        } else {
                            // iOS Safariなど、download属性の挙動を保証できない環境では画像を開く。
                            // 端末へ保存されたとは断言せず、画面側で手動保存を案内する。
                            var manualObjectUrl = URL.createObjectURL(blob);
                            var opened = window.open(manualObjectUrl, '_blank');
                            setTimeout(function() { URL.revokeObjectURL(manualObjectUrl); }, 60000);
                            resolve(opened ? 'manual' : 'unsupported');
                        }
                    }

                    saveViaDownloadOrOpen();
                }, 'image/jpeg', 0.92);
            }).catch(reject);
        }))
        ,
    'dev.rdd.jiku.hideCameraSyncViewfinder' : () => { 
            var overlay = window.__jikuCameraSyncOverlay;
            if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
            window.__jikuCameraSyncOverlay = null;
            window.__jikuCameraSyncStatusLabel = null;
            window.__jikuCameraSyncParticipantsContainer = null;
            window.__jikuCameraSyncReadyButton = null;
            window.__jikuCameraSyncShutterButton = null;
            var video = window.__jikuCameraSyncVideo;
            if (video) {
                video.setAttribute('style', 'position:fixed;width:1px;height:1px;opacity:0;pointer-events:none;');
            }
             },
    'dev.rdd.jiku.closeCameraSyncStream' : () => { 
            if (window.__jikuCameraSyncOverlay) {
                window.__jikuCameraSyncOverlay.parentNode.removeChild(window.__jikuCameraSyncOverlay);
                window.__jikuCameraSyncOverlay = null;
                window.__jikuCameraSyncStatusLabel = null;
                window.__jikuCameraSyncParticipantsContainer = null;
                window.__jikuCameraSyncReadyButton = null;
                window.__jikuCameraSyncShutterButton = null;
            }
            if (window.__jikuCameraSyncStream) {
                window.__jikuCameraSyncStream.getTracks().forEach(function(t) { t.stop(); });
                window.__jikuCameraSyncStream = null;
            }
            if (window.__jikuCameraSyncVideo && window.__jikuCameraSyncVideo.parentNode) {
                window.__jikuCameraSyncVideo.parentNode.removeChild(window.__jikuCameraSyncVideo);
            }
            window.__jikuCameraSyncVideo = null;
             },
    'dev.rdd.jiku.showCameraSyncViewfinder' : (onReadyClick, onShutterClick) => { 
            var video = window.__jikuCameraSyncVideo;
            if (!video || window.__jikuCameraSyncOverlay) return;
            video.setAttribute('style', 'position:fixed;top:0;left:0;width:100%;height:100%;object-fit:cover;z-index:2147483646;');

            var overlay = document.createElement('div');
            overlay.setAttribute(
                'style',
                'position:fixed;top:0;left:0;width:100%;height:100%;z-index:2147483647;' +
                'display:flex;flex-direction:column;justify-content:space-between;'
            );

            var panel = document.createElement('div');
            panel.setAttribute(
                'style',
                'margin:24px 16px 0 16px;padding:16px;border-radius:12px;' +
                'background:rgba(32,32,36,0.8);color:#fff;font-family:sans-serif;'
            );
            var statusLabel = document.createElement('div');
            statusLabel.setAttribute('style', 'padding-bottom:8px;');
            panel.appendChild(statusLabel);
            var participantsContainer = document.createElement('div');
            panel.appendChild(participantsContainer);
            overlay.appendChild(panel);

            function makeButton(label, onClick) {
                var button = document.createElement('button');
                button.textContent = label;
                button.setAttribute(
                    'style',
                    'padding:14px 24px;border:none;border-radius:999px;background:#3FBFA9;' +
                    'color:#00201B;font-weight:bold;font-family:sans-serif;'
                );
                button.onclick = function() { onClick(); };
                return button;
            }
            var readyButton = makeButton('準備完了', onReadyClick);
            var shutterButton = makeButton('撮影を送る', onShutterClick);
            var buttonsRow = document.createElement('div');
            buttonsRow.setAttribute('style', 'display:flex;justify-content:center;gap:16px;margin-bottom:32px;');
            buttonsRow.appendChild(readyButton);
            buttonsRow.appendChild(shutterButton);
            overlay.appendChild(buttonsRow);

            document.body.appendChild(overlay);
            window.__jikuCameraSyncOverlay = overlay;
            window.__jikuCameraSyncStatusLabel = statusLabel;
            window.__jikuCameraSyncParticipantsContainer = participantsContainer;
            window.__jikuCameraSyncReadyButton = readyButton;
            window.__jikuCameraSyncShutterButton = shutterButton;
             },
    'dev.rdd.jiku.compositeFromBase64ListPromise' : (base64ListJson) => 
        (new Promise(function(resolve) {
            window.__jikuPendingFiles = window.__jikuPendingFiles || {};
            window.__jikuNextPickId = window.__jikuNextPickId || 0;
            var base64List = JSON.parse(base64ListJson);
            if (base64List.length === 0) { resolve(''); return; }
            var loaders = base64List.map(function(b64) {
                return new Promise(function(resolveImg) {
                    var img = new Image();
                    img.onload = function() { resolveImg(img); };
                    img.onerror = function() { resolveImg(null); };
                    img.src = 'data:image/jpeg;base64,' + b64;
                });
            });
            Promise.all(loaders).then(function(images) {
                var valid = images.filter(function(img) { return img !== null; });
                if (valid.length === 0) { resolve(''); return; }
                var cols = Math.ceil(Math.sqrt(valid.length));
                var rows = Math.ceil(valid.length / cols);
                var cellSize = 800;
                var canvas = document.createElement('canvas');
                canvas.width = cols * cellSize;
                canvas.height = rows * cellSize;
                var ctx = canvas.getContext('2d');
                ctx.fillStyle = '#000';
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                valid.forEach(function(img, index) {
                    var col = index % cols;
                    var row = Math.floor(index / cols);
                    var scale = Math.max(cellSize / img.width, cellSize / img.height);
                    var w = img.width * scale;
                    var h = img.height * scale;
                    var dx = col * cellSize + (cellSize - w) / 2;
                    var dy = row * cellSize + (cellSize - h) / 2;
                    ctx.drawImage(img, dx, dy, w, h);
                });
                canvas.toBlob(function(blob) {
                    if (!blob) { resolve(''); return; }
                    var id = 'composite' + (window.__jikuNextPickId++);
                    window.__jikuPendingFiles[id] = new File([blob], 'camera-sync-composite.jpg', { type: 'image/jpeg' });
                    resolve(id);
                }, 'image/jpeg', 0.9);
            });
        }))
        ,
    'dev.rdd.jiku.uploadCameraSyncPhotoPromise' : (url, authToken, pickId, albumId) => 
        (new Promise(function(resolve, reject) {
            var file = window.__jikuPendingFiles ? window.__jikuPendingFiles[pickId] : null;
            if (!file) { reject(new Error('picked file not found: ' + pickId)); return; }
            var formData = new FormData();
            formData.append('file', file, 'camera-sync.jpg');
            if (albumId) formData.append('albumId', albumId);
            fetch(url, {
                method: 'POST',
                headers: { 'Authorization': 'Bearer ' + authToken },
                body: formData,
            }).then(function(r) {
                return r.text().then(function(t) {
                    if (!r.ok) { reject(new Error('HTTP ' + r.status + ': ' + t)); return; }
                    delete window.__jikuPendingFiles[pickId];
                    resolve(t);
                });
            }).catch(function(e) { reject(e); });
        }))
        ,
    'dev.rdd.jiku.captureCameraSyncFramePromise' : () => 
        (new Promise(function(resolve) {
            window.__jikuPendingFiles = window.__jikuPendingFiles || {};
            window.__jikuNextPickId = window.__jikuNextPickId || 0;
            var video = window.__jikuCameraSyncVideo;
            if (!video || !video.videoWidth) { resolve(''); return; }
            var canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            canvas.toBlob(function(blob) {
                if (!blob) { resolve(''); return; }
                var id = 'sync' + (window.__jikuNextPickId++);
                window.__jikuPendingFiles[id] = new File([blob], 'camera-sync.jpg', { type: 'image/jpeg' });
                resolve(id);
            }, 'image/jpeg', 0.92);
        }))
        ,
    'dev.rdd.jiku.openCameraSyncStreamPromise' : () => 
        (new Promise(function(resolve) {
            if (window.__jikuCameraSyncStream) { resolve('ok'); return; }
            var media = navigator.mediaDevices;
            if (!media || !media.getUserMedia) { resolve(''); return; }
            media.getUserMedia({ video: { facingMode: { ideal: 'environment' } }, audio: false }).catch(function() {
                return media.getUserMedia({ video: true, audio: false });
            }).then(function(stream) {
                var video = document.createElement('video');
                video.setAttribute('playsinline', '');
                video.autoplay = true;
                video.muted = true;
                video.srcObject = stream;
                // autoplay属性だけに頼らず、DOMに一切繋がっていない<video>要素でも確実に
                // デコード・再生が始まるよう、視覚的には見えない形でdocument.bodyへ繋いだ上で
                // play()を明示的に呼ぶ(Androidの隠しPreviewViewと同じ理由。完全に浮いたままの
                // 要素だと再生が始まらないブラウザがある)
                video.setAttribute('style', 'position:fixed;width:1px;height:1px;opacity:0;pointer-events:none;');
                document.body.appendChild(video);
                window.__jikuCameraSyncStream = stream;
                window.__jikuCameraSyncVideo = video;
                video.play().then(function() { resolve('ok'); }).catch(function() { resolve(''); });
            }).catch(function() { resolve(''); });
        }))
        ,
    'dev.rdd.jiku.jsConnectSocket' : (url, onOpen, onMessage, onClose) => 
        (function() {
            var ws = new WebSocket(url);
            ws.onopen = function() { onOpen(); };
            ws.onmessage = function(event) { onMessage(event.data); };
            ws.onclose = function() { onClose(); };
            ws.onerror = function() {};
            return ws;
        })()
        ,
    'dev.rdd.jiku.__convertKotlinClosureToJsClosure_((String)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String)->Unit)'](f, p0)),
    'dev.rdd.jiku.updateCameraSyncViewfinderJs' : (statusLabel, participantsJson, showReadyButton, readyButtonEnabled, readyButtonLabel, showShutterButton, shutterButtonEnabled, shutterButtonLabel) => { 
            var label = window.__jikuCameraSyncStatusLabel;
            if (label) label.textContent = statusLabel;
            var container = window.__jikuCameraSyncParticipantsContainer;
            if (container) {
                container.innerHTML = '';
                JSON.parse(participantsJson).forEach(function(p) {
                    var row = document.createElement('div');
                    row.textContent = p.name + ': ' + p.statusLabel;
                    container.appendChild(row);
                });
            }
            var readyButton = window.__jikuCameraSyncReadyButton;
            if (readyButton) {
                readyButton.style.display = showReadyButton ? '' : 'none';
                readyButton.disabled = !readyButtonEnabled;
                readyButton.style.opacity = readyButtonEnabled ? '1' : '0.5';
                readyButton.textContent = readyButtonLabel;
            }
            var shutterButton = window.__jikuCameraSyncShutterButton;
            if (shutterButton) {
                shutterButton.style.display = showShutterButton ? '' : 'none';
                shutterButton.disabled = !shutterButtonEnabled;
                shutterButton.style.opacity = shutterButtonEnabled ? '1' : '0.5';
                shutterButton.textContent = shutterButtonLabel;
            }
             },
    'dev.rdd.jiku.jsSocketSend' : (handle, message) => { handle.send(message) },
    'dev.rdd.jiku.jsSocketClose' : (handle) => { handle.close() },
    'dev.rdd.jiku.nextFetchRequestIdJs' : () => 
        (function() {
            window.__jikuFetchRequestSeq = (window.__jikuFetchRequestSeq || 0) + 1;
            return window.__jikuFetchRequestSeq;
        })()
        ,
    'dev.rdd.jiku.abortFetchRequest' : (requestId) => { 
            (function() {
                var controller = window.__jikuFetchControllers && window.__jikuFetchControllers[requestId];
                if (controller) controller.abort();
            })()
             },
    'dev.rdd.jiku.preloadGoogleIdentityServices' : () => { 
            if (!document.getElementById('google-identity-script')) {
                var s = document.createElement('script');
                s.id = 'google-identity-script';
                s.src = 'https://accounts.google.com/gsi/client';
                s.async = true;
                document.head.appendChild(s);
            }
             },
    'dev.rdd.jiku.googleAccessTokenPromise' : (clientId) => 
        (new Promise(function(resolve, reject) {
            function start() {
                var client = google.accounts.oauth2.initTokenClient({
                    client_id: clientId,
                    scope: 'email profile',
                    callback: function(tokenResponse) {
                        if (tokenResponse.error) {
                            reject(new Error(tokenResponse.error + ': ' + (tokenResponse.error_description || '')));
                        } else {
                            resolve(tokenResponse.access_token);
                        }
                    },
                    error_callback: function(err) {
                        reject(new Error((err && err.type) || 'google popup failed'));
                    }
                });
                client.requestAccessToken();
            }
            if (window.google && window.google.accounts && window.google.accounts.oauth2) {
                start();
            } else if (!document.getElementById('google-identity-script')) {
                var s = document.createElement('script');
                s.id = 'google-identity-script';
                s.src = 'https://accounts.google.com/gsi/client';
                s.async = true;
                s.onload = start;
                s.onerror = function() { reject(new Error('failed to load Google Identity Services script')); };
                document.head.appendChild(s);
            } else {
                // 事前ロード用のscriptタグ(index.html)がまだロード中の場合はloadイベントを待つ
                var tag = document.getElementById('google-identity-script');
                tag.addEventListener('load', start, { once: true });
                tag.addEventListener('error', function() { reject(new Error('failed to load Google Identity Services script')); }, { once: true });
            }
        }))
        ,
    'dev.rdd.jiku.fetchJsonPromise' : (url, method, bodyJson, authToken, requestId, timeoutMs) => 
        (new Promise(function(resolve, reject) {
            window.__jikuFetchControllers = window.__jikuFetchControllers || {};
            var controller = new AbortController();
            window.__jikuFetchControllers[requestId] = controller;
            var timer = setTimeout(function() { controller.abort(); }, timeoutMs);
            function cleanup() {
                clearTimeout(timer);
                delete window.__jikuFetchControllers[requestId];
            }
            fetch(url, {
                method: method,
                headers: Object.assign(
                    { 'Content-Type': 'application/json' },
                    authToken ? { 'Authorization': 'Bearer ' + authToken } : {}
                ),
                body: bodyJson ? bodyJson : undefined,
                signal: controller.signal
            }).then(function(r) {
                return r.text().then(function(t) {
                    if (!r.ok) throw new Error('HTTP ' + r.status + ': ' + t);
                    return t;
                });
            }).then(function(result) {
                cleanup();
                resolve(result);
            }).catch(function(e) {
                cleanup();
                reject(e);
            });
        }))
        ,
    'dev.rdd.jiku.currentPathJs' : () => window.location.pathname,
    'dev.rdd.jiku.navigateToAppRoot' : () => { window.location.href = '/' },
    'dev.rdd.jiku.loadSessionTokenJs' : () => localStorage.getItem('jiku_session_token'),
    'dev.rdd.jiku.removeSessionTokenJs' : () => { localStorage.removeItem('jiku_session_token') },
    'dev.rdd.jiku.saveSessionTokenJs' : (token) => { localStorage.setItem('jiku_session_token', token) },
    'dev.rdd.jiku.pushUrlPath' : (path) => { window.history.pushState(null, '', path) },
    'dev.rdd.jiku.registerPopStateJs' : (onPopState) => 
        (function() {
            var handler = function() { onPopState(); };
            window.addEventListener('popstate', handler);
            return handler;
        })()
        ,
    'dev.rdd.jiku.unregisterPopStateJs' : (handler) => { window.removeEventListener('popstate', handler) },
    'dev.rdd.jiku.releasePickedFile' : (pickId) => { if (window.__jikuPendingFiles) delete window.__jikuPendingFiles[pickId] },
    'dev.rdd.jiku.hasGetUserMediaJs' : () => !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia),
    'dev.rdd.jiku.fetchPickedImageBytesBase64Promise' : (pickId) => 
        (new Promise(function(resolve, reject) {
            var file = window.__jikuPendingFiles ? window.__jikuPendingFiles[pickId] : null;
            if (!file) { reject(new Error('picked file not found: ' + pickId)); return; }
            file.arrayBuffer().then(function(buf) {
                var bytes = new Uint8Array(buf);
                var binary = '';
                var chunkSize = 0x8000;
                for (var i = 0; i < bytes.length; i += chunkSize) {
                    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunkSize));
                }
                resolve(btoa(binary));
            }).catch(function(e) { reject(e); });
        }))
        ,
    'dev.rdd.jiku.captureOverlayPromise' : (optionsJson) => 
        (new Promise(function(resolve) {
            // 前回の撮影で開いたビューファインダー(getUserMediaのストリーム)がまだ生きていれば、
            // 開き直さずそのまま使い回す(通知・プレビュー表示中の再撮影対応)。以前は撮るたびに
            // ここで必ず新しいストリームを開いており、その切り替えの一瞬だけ黒画面が見えるのを
            // 隠すために、Kotlin側(CameraScreen.kt)が2.3秒だけ次の呼び出しを遅らせていた。
            // 結果として、その間はシャッターを再度押せなかった
            var existingRearm = window.__jikuViewfinderRearm;
            if (existingRearm) { existingRearm(resolve); return; }

            window.__jikuPendingFiles = window.__jikuPendingFiles || {};
            window.__jikuNextPickId = window.__jikuNextPickId || 0;

            var media = navigator.mediaDevices;
            if (!media || !media.getUserMedia) { resolve('{"files":[],"error":"no-camera"}'); return; }

            var handoffFrame = window.__jikuCameraHandoffFrame || '';
            var overlay = document.createElement('div');
            overlay.setAttribute('style', 'position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147483647;background:#17171A;display:flex;align-items:center;justify-content:center;' + (handoffFrame ? 'background-image:url("' + handoffFrame + '");background-position:center;background-size:contain;background-repeat:no-repeat;' : ''));
            // シャッター直後の白いフラッシュ。撮影の開始を視覚だけで即座に伝える。
            var flash = document.createElement('div');
            flash.setAttribute('style', 'position:absolute;inset:0;background:#fff;opacity:0;pointer-events:none;transition:opacity 65ms ease-out;z-index:4;');
            var video = document.createElement('video');
            // iOS Safariはplaysinlineが無いと全画面の純正プレイヤーで再生してしまう
            video.setAttribute('playsinline', '');
            video.autoplay = true;
            video.muted = true;
            video.setAttribute('style', 'width:100%;height:100%;object-fit:contain;background:transparent;');
            // このオーバーレイはCompose(canvas)の外にDOMで組むため、アプリ側のコンポーネントを
            // 再利用できない。見た目が別アプリにならないよう、デザインv7の語彙
            // (地=#000 / 面=#131315 / 極細の輪郭=#2C2C2E / 主操作=ミント)をここで再現する。
            // 左右は上部バーと同じ44pxの円形アイコンボタン、中央はカメラタブと同じミントの丸
            var INK = '#fff', SURFACE = '#202024', OUTLINE = '#35353C', MINT = '#3FBFA9', ON_MINT = '#00201B';
            var circleStyle = 'width:44px;height:44px;border-radius:50%;background:' + SURFACE +
                ';border:1px solid ' + OUTLINE + ';color:' + INK +
                ';display:flex;align-items:center;justify-content:center;padding:0;cursor:pointer;';

            var bar = document.createElement('div');
            bar.setAttribute('style', 'position:absolute;left:0;right:0;bottom:0;padding:20px 20px 32px;display:flex;align-items:center;justify-content:space-between;');

            var cancelButton = document.createElement('button');
            cancelButton.type = 'button';
            cancelButton.setAttribute('aria-label', 'キャンセル');
            cancelButton.setAttribute('style', circleStyle);
            cancelButton.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';

            var shutterButton = document.createElement('button');
            shutterButton.type = 'button';
            shutterButton.setAttribute('aria-label', '撮影');
            shutterButton.setAttribute('style', 'width:64px;height:64px;border-radius:50%;background:' + MINT +
                ';border:none;color:' + ON_MINT + ';display:flex;align-items:center;justify-content:center;padding:0;cursor:pointer;');
            shutterButton.innerHTML = '<svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor"><path d="M9 3 7.2 5H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-3.2L15 3H9zm3 5a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11zm0 2a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7z"/></svg>';

            // 内カメ/外カメの切り替え(以前ここは幅合わせのための空divだった)。
            // 文字の「切替」ではなく、カメラアプリで見慣れた円環の矢印にする
            var switchButton = document.createElement('button');
            switchButton.type = 'button';
            switchButton.setAttribute('aria-label', '内カメラと外カメラを切り替える');
            switchButton.setAttribute('style', circleStyle);
            switchButton.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="21 4 21 9 16 9"/><polyline points="3 20 3 15 8 15"/><path d="M19.4 9A8 8 0 0 0 5.6 6.6L3 9"/><path d="M4.6 15A8 8 0 0 0 18.4 17.4L21 15"/></svg>';

            bar.appendChild(cancelButton);
            bar.appendChild(shutterButton);
            bar.appendChild(switchButton);
            // 投稿先のセレクト(カメラタブから開いたときだけ)。撮る前に別画面で選ばせず、
            // ビューファインダーを見ながら行き先を変えられるようにする。
            // 写真はアルバムに直接入るため、必ず選ぶのはアルバムだけ。タグは任意で、
            // 既定では付けない
            var albumSelect = null;
            var valueSelect = null;
            var options = null;
            try { options = optionsJson ? JSON.parse(optionsJson) : null; } catch (e) { options = null; }
            if (options && options.albums && options.albums.length) {
                // アルバム名と値を横に並べると1つあたりの幅が半分になり、名前が長いだけで
                // 読めなくなっていた。縦に積んで全幅を使い、文字も本文と同じ大きさにする
                var selectStyle = 'width:100%;box-sizing:border-box;background:' + SURFACE + ';color:' + INK +
                    ';border:1px solid ' + OUTLINE + ';border-radius:999px;padding:12px 16px;font-size:17px;' +
                    'appearance:none;-webkit-appearance:none;cursor:pointer;';
                var topBar = document.createElement('div');
                topBar.setAttribute('style', 'position:absolute;left:0;right:0;top:0;padding:16px;display:flex;flex-direction:column;gap:8px;');
                albumSelect = document.createElement('select');
                albumSelect.setAttribute('aria-label', 'アルバムを選ぶ');
                albumSelect.setAttribute('style', selectStyle);
                valueSelect = document.createElement('select');
                valueSelect.setAttribute('aria-label', '値を選ぶ');
                valueSelect.setAttribute('style', selectStyle);
                options.albums.forEach(function(album) {
                    var opt = document.createElement('option');
                    opt.value = album.id;
                    opt.textContent = album.name;
                    albumSelect.appendChild(opt);
                });
                function fillValues() {
                    var album = null;
                    options.albums.forEach(function(a) { if (a.id === albumSelect.value) album = a; });
                    valueSelect.innerHTML = '';
                    // タグは任意。既定では付けずに撮れる
                    var none = document.createElement('option');
                    none.value = '';
                    none.textContent = 'タグを付けない';
                    valueSelect.appendChild(none);
                    (album && album.tags ? album.tags : []).forEach(function(t) {
                        var opt = document.createElement('option');
                        opt.value = t.id;
                        opt.textContent = t.name;
                        valueSelect.appendChild(opt);
                    });
                    // タグが1つも無いアルバムでは、選ぶものが無いのでセレクト自体を出さない
                    valueSelect.style.display = (valueSelect.options.length > 1) ? '' : 'none';
                }
                albumSelect.onchange = fillValues;
                if (options.selectedAlbumId) albumSelect.value = options.selectedAlbumId;
                fillValues();
                if (options.selectedTagId) valueSelect.value = options.selectedTagId;
                topBar.appendChild(albumSelect);
                topBar.appendChild(valueSelect);
                overlay.appendChild(video);
                overlay.appendChild(topBar);
            } else {
                overlay.appendChild(video);
            }
            overlay.appendChild(flash);
            overlay.appendChild(bar);

            var stream = null;
            var settled = false;
            // いま結果を待っているPromiseのresolve。1枚渡すたびにnullへ戻し、次の
            // captureOverlayPromise呼び出しがwindow.__jikuViewfinderRearmで積み直すまで
            // シャッターを再度押せないようにする(ここを空けたまま連打を許すと、
            // 積み直しが間に合う前の1枚が誰にも受け取られず消える恐れがある)
            var activeResolve = resolve;
            window.__jikuViewfinderRearm = function(newResolve) {
                activeResolve = newResolve;
                if (!settled) shutterButton.disabled = false;
            };
            // 切り替え中の再入(連打)を防ぐ。掴み直しの途中でもう一度押されると、
            // 古いストリームを止めた直後の何も無い状態で二重に開きにいってしまう
            var switching = false;
            // 使えるカメラの一覧と、いま使っている位置。facingModeの'ideal'指定だけに頼ると、
            // 前面/背面という区別を持たないPCでは同じカメラがそのまま返り、切り替えたつもりが
            // プレビューの鏡像が入れ替わるだけになる。実際のデバイスを列挙して順に回す
            var cameras = [];
            var cameraIndex = 0;
            function stopStream() {
                if (!stream) return;
                stream.getTracks().forEach(function(track) { track.stop(); });
                stream = null;
            }
            var closeViewfinder = null;
            function clearCloseViewfinder() {
                if (window.__jikuCloseViewfinder === closeViewfinder) window.__jikuCloseViewfinder = null;
            }
            function onKeyDown(event) {
                if (event.key === 'Escape') finish('{"files":[]}');
            }
            function finish(value) {
                if (settled) return;
                settled = true;
                window.__jikuViewfinderRearm = null;
                document.removeEventListener('keydown', onKeyDown);
                stopStream();
                window.__jikuCameraHandoffFrame = null;
                if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
                clearCloseViewfinder();
                var cb = activeResolve;
                activeResolve = null;
                if (cb) cb(value);
            }
            // 1枚ぶんの結果を呼び出し元へ返し、次にwindow.__jikuViewfinderRearmが呼ばれるまで
            // シャッターを再度ロックする。映像・ストリームはここでは畳まない(以前はここで
            // 畳む予約をしていたが、それが「通知・プレビュー表示中は再撮影できない」原因
            // だった)。カメラタブから離れる・キャンセル・Escで閉じるまで、同じ映像のまま
            // 何枚でも撮り続けられる
            function deliverAndUnlock(value) {
                cancelButton.disabled = false;
                switchButton.disabled = false;
                var cb = activeResolve;
                activeResolve = null;
                shutterButton.disabled = true;
                cb(value);
            }

            function errorCode(e) {
                var name = (e && e.name) ? e.name : '';
                if (name === 'NotAllowedError' || name === 'PermissionDeniedError' || name === 'SecurityError') return 'permission-denied';
                if (name === 'NotFoundError' || name === 'DevicesNotFoundError' || name === 'OverconstrainedError') return 'no-camera';
                return 'capture-failed';
            }

            cancelButton.onclick = function() { finish('{"files":[]}'); };
            shutterButton.onclick = function() {
                // activeResolveがnullの間(前の1枚を渡した直後、次の呼び出し元がrearmするまでの
                // ごく短い間)は、まだ誰も次の結果を受け取れる状態にないため撮らせない
                if (settled || !activeResolve) return;
                var width = video.videoWidth;
                var height = video.videoHeight;
                // 映像の最初のフレームが来る前に押された場合は、真っ黒な写真を作らずに何もしない
                if (!width || !height) return;
                shutterButton.disabled = true;
                cancelButton.disabled = true;
                switchButton.disabled = true;
                var canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                canvas.getContext('2d').drawImage(video, 0, 0, width, height);
                // 右下の縮小プレビューは、フルサイズJPEGのエンコード完了を待たずに表示する。
                // 写真の実体とは別の小さなCanvasにすることで、メモリと表示遅延を抑える。
                var previewSize = 88;
                var scale = Math.min(1, previewSize / Math.max(width, height));
                var previewCanvas = document.createElement('canvas');
                previewCanvas.width = Math.max(1, Math.round(width * scale));
                previewCanvas.height = Math.max(1, Math.round(height * scale));
                previewCanvas.getContext('2d').drawImage(canvas, 0, 0, previewCanvas.width, previewCanvas.height);
                // 次のビューファインダーが映像を受け取るまでのつなぎ用。フル解像度では保持せず、
                // 長辺720pxの静止画だけを残して黒い空白を見せない。
                var handoffSize = 720;
                var handoffScale = Math.min(1, handoffSize / Math.max(width, height));
                var handoffCanvas = document.createElement('canvas');
                handoffCanvas.width = Math.max(1, Math.round(width * handoffScale));
                handoffCanvas.height = Math.max(1, Math.round(height * handoffScale));
                handoffCanvas.getContext('2d').drawImage(canvas, 0, 0, handoffCanvas.width, handoffCanvas.height);
                window.__jikuCameraHandoffFrame = handoffCanvas.toDataURL('image/jpeg', 0.82);
                var preview = document.createElement('img');
                preview.src = previewCanvas.toDataURL('image/jpeg', 0.72);
                preview.setAttribute('aria-label', '撮影した写真のプレビュー');
                // いま写っていたものが手元に収まっていくように見せたいので、画面の中央に
                // 大きめで出してから右下の定位置へ寄せる(いきなり右下に現れると目で追えない)
                var toCenterX = 64 - window.innerWidth / 2;
                var toCenterY = 160 - window.innerHeight / 2;
                preview.setAttribute('style', 'position:absolute;right:20px;bottom:116px;width:88px;height:88px;object-fit:cover;border-radius:12px;border:2px solid #fff;box-shadow:0 4px 14px rgba(0,0,0,.42);z-index:5;opacity:0;' +
                    'transform:translate(' + toCenterX + 'px,' + toCenterY + 'px) scale(2.4);');
                overlay.appendChild(preview);
                requestAnimationFrame(function() {
                    preview.style.transition = 'transform 620ms cubic-bezier(.16,.84,.34,1),opacity 220ms ease-out';
                    preview.style.transform = 'translate(0,0) scale(1)';
                    preview.style.opacity = '1';
                });
                var destinationNotice = document.createElement('div');
                // 投稿先とタグの選択に重ならないよう、その下に出す。タグが無いアルバムでは
                // 選択自体が1つぶん短くなるため、位置は実際の高さから決める
                var noticeTop = (typeof topBar !== 'undefined' && topBar)
                    ? Math.round(topBar.getBoundingClientRect().height) + 12
                    : 124;
                var destinationName = albumSelect && albumSelect.selectedIndex >= 0
                    ? albumSelect.options[albumSelect.selectedIndex].textContent
                    : '選んだアルバム';
                destinationNotice.setAttribute('style', 'position:absolute;right:20px;top:' + noticeTop + 'px;max-width:calc(100vw - 40px);box-sizing:border-box;padding:8px 12px;border-radius:999px;background:#3FBFA9;color:#00201B;font-size:14px;font-weight:600;white-space:nowrap;display:inline-flex;align-items:center;pointer-events:none;z-index:5;opacity:1;transform:translateX(0);transition:transform 560ms ease-in,opacity 560ms ease-in;');
                var destinationPrefix = document.createElement('span');
                destinationPrefix.textContent = '「';
                destinationPrefix.setAttribute('style', 'flex:0 0 auto;');
                var destinationAlbum = document.createElement('span');
                destinationAlbum.textContent = destinationName;
                destinationAlbum.setAttribute('style', 'min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;');
                var destinationSuffix = document.createElement('span');
                destinationSuffix.textContent = '」に保存中';
                destinationSuffix.setAttribute('style', 'flex:0 0 auto;');
                destinationNotice.appendChild(destinationPrefix);
                destinationNotice.appendChild(destinationAlbum);
                destinationNotice.appendChild(destinationSuffix);
                overlay.appendChild(destinationNotice);
                flash.style.opacity = '1';
                setTimeout(function() { flash.style.opacity = '0'; }, 20);
                // 定位置で少し見せてから、次の撮影の邪魔にならないよう右へゆっくり流して消す。
                // 以前はここから先、映像ごと畳む(finishAfterFeedback)タイミングでこれらの要素も
                // 一緒に消えていたが、今は同じ映像のまま何枚でも撮り続けるため、消え終わったら
                // 自分自身をoverlayから取り除く(連写しても古いプレビューが積み重ならないように)
                setTimeout(function() {
                    preview.style.transition = 'transform 900ms ease-in,opacity 900ms ease-in';
                    preview.style.transform = 'translateX(140px)';
                    preview.style.opacity = '0';
                    destinationNotice.style.transition = 'transform 900ms ease-in,opacity 900ms ease-in';
                    destinationNotice.style.transform = 'translateX(140px)';
                    destinationNotice.style.opacity = '0';
                    setTimeout(function() {
                        if (preview.parentNode) preview.parentNode.removeChild(preview);
                        if (destinationNotice.parentNode) destinationNotice.parentNode.removeChild(destinationNotice);
                    }, 900);
                }, 1400);
                canvas.toBlob(function(blob) {
                    // フル解像度のJPEGエンコードは数十〜数百ms かかり、その間もキャンセル・Escは
                    // 生きている。既に終了(settled)しているのにここでマップへ登録すると、Kotlin側は
                    // pickIdを受け取らないためreleasePickedFileが永久に呼ばれず、数MBのBlobが
                    // window上に残り続ける(PR #268 レビュー指摘)
                    if (settled) return;
                    if (!blob) { finish('{"files":[],"error":"capture-failed"}'); return; }
                    var name = 'camera-' + Date.now() + '.jpg';
                    var file;
                    // Fileコンストラクタ未対応の環境ではBlobにname/lastModifiedを生やして代用する
                    // (後段はfile.name・file.type・file.size・file.arrayBuffer()しか使わない)
                    try {
                        file = new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() });
                    } catch (e) {
                        file = blob;
                        file.name = name;
                    }
                    var id = 'f' + (window.__jikuNextPickId++);
                    window.__jikuPendingFiles[id] = file;
                    var result = JSON.stringify({
                        files: [{ pickId: id, name: name }],
                        axisId: albumSelect ? albumSelect.value : null,
                        tagId: (valueSelect && valueSelect.value) ? valueSelect.value : null,
                    });
                    deliverAndUnlock(result);
                }, 'image/jpeg', 0.92);
            };

            document.addEventListener('keydown', onKeyDown);
            document.body.appendChild(overlay);
            // カメラタブから離れたときに外から畳めるようにする(残るとカメラを掴んだままになる)。
            // 以前は撮影完了後に「結果は返したが映像はまだ畳んでいない」猶予期間があり、その
            // 場合の後始末も別途ここで行っていたが、今はfinish()だけが実際に畳む唯一の経路に
            // なったため、settledなら何もしなくてよい(finish自体もsettled済みなら無害)
            closeViewfinder = function() { finish('{"files":[]}'); };
            window.__jikuCloseViewfinder = closeViewfinder;

            function applyStream(mediaStream) {
                // 許可ダイアログを待っている間にキャンセルされた場合、掴んだカメラをそのまま離す
                if (settled) {
                    mediaStream.getTracks().forEach(function(track) { track.stop(); });
                    return;
                }
                stream = mediaStream;
                video.srcObject = mediaStream;
                // 内カメだけプレビューを鏡像にする。どちら向きかは要求した値ではなく、実際に
                // 掴めたカメラの設定から見る(要求どおりの向きが得られるとは限らないため)。
                // canvasにはvideoの生フレームを描くので、保存される写真は鏡像にならない
                var track = mediaStream.getVideoTracks()[0];
                var settings = (track && track.getSettings) ? track.getSettings() : {};
                video.style.transform = (settings.facingMode === 'user') ? 'scaleX(-1)' : 'none';
                video.onplaying = function() {
                    // 新しい映像が描画できた時点で、つなぎ用の静止画を解放する。
                    window.__jikuCameraHandoffFrame = null;
                    overlay.style.backgroundImage = 'none';
                };
                var playing = video.play();
                if (playing && playing.catch) playing.catch(function() {});
            }
            function openCamera(mode) {
                return media.getUserMedia({ video: { facingMode: { ideal: mode } }, audio: false }).catch(function() {
                    // facingModeの指定ごと失敗する環境(PCの外付けカメラ等)では制約なしで再試行する
                    return media.getUserMedia({ video: true, audio: false });
                });
            }
            function openCameraAt(index) {
                var device = cameras[index];
                if (!device) return Promise.reject(new Error('no camera'));
                return media.getUserMedia({ video: { deviceId: { exact: device.deviceId } }, audio: false });
            }
            // 切り替えボタンはカメラが1台しか無い環境でも消さずに出しておく。
            // 消してしまうと「この画面で内カメ/外カメを切り替えられる」こと自体が伝わらず、
            // 検証時にも機能の有無を確かめられないため。
            // ただし切り替え先が無いときは押しても同じ映像に戻るだけなので、disabledにして
            // 半透明にし、いまは押せないことを見た目で示す
            // deviceIdは撮影の許可が下りるまで空になるため、最初のストリームを掴んだ後に呼ぶ
            function setSwitchEnabled(enabled) {
                switchButton.disabled = !enabled;
                switchButton.style.opacity = enabled ? '1' : '0.45';
                switchButton.style.cursor = enabled ? 'pointer' : 'default';
            }
            function refreshCameras() {
                if (!media.enumerateDevices) { setSwitchEnabled(false); return Promise.resolve(); }
                return media.enumerateDevices().then(function(devices) {
                    cameras = devices.filter(function(d) { return d.kind === 'videoinput'; });
                    var current = stream ? stream.getVideoTracks()[0] : null;
                    var currentSettings = (current && current.getSettings) ? current.getSettings() : {};
                    cameras.forEach(function(d, i) {
                        if (currentSettings.deviceId && d.deviceId === currentSettings.deviceId) cameraIndex = i;
                    });
                    setSwitchEnabled(cameras.length > 1);
                }).catch(function() { setSwitchEnabled(false); });
            }
            switchButton.onclick = function() {
                if (settled || switching || cameras.length < 2) return;
                switching = true;
                var previous = cameraIndex;
                var next = (cameraIndex + 1) % cameras.length;
                // 2つのカメラを同時に掴めない端末があるため、先に離してから開き直す。
                // 開き直しに失敗したら元のカメラへ戻し、真っ暗なまま取り残さないようにする
                stopStream();
                openCameraAt(next).then(function(mediaStream) {
                    cameraIndex = next;
                    applyStream(mediaStream);
                }).catch(function() {
                    return openCameraAt(previous).then(function(mediaStream) {
                        cameraIndex = previous;
                        applyStream(mediaStream);
                    });
                }).catch(function(e) {
                    finish(JSON.stringify({ files: [], error: errorCode(e) }));
                }).then(function() { switching = false; });
            };
            // 最初は外カメを要求する。カメラの数が分かるまでは切り替え先を決められないため、
            // ボタンは出したまま押せない状態にしておき、掴めてから有効・無効を確定させる
            setSwitchEnabled(false);
            openCamera('environment').then(function(mediaStream) {
                applyStream(mediaStream);
                return refreshCameras();
            }).catch(function(e) {
                finish(JSON.stringify({ files: [], error: errorCode(e) }));
            });
        }))
        ,
    'dev.rdd.jiku.uploadPickedImagePromise' : (url, authToken, pickId, tagIdsJson, albumId, requestId, timeoutMs) => 
        (new Promise(function(resolve, reject) {
            var file = window.__jikuPendingFiles ? window.__jikuPendingFiles[pickId] : null;
            if (!file) { reject(new Error('picked file not found: ' + pickId)); return; }
            var tagIds = JSON.parse(tagIdsJson);

            // UPLOAD_TIMEOUT_MSは送信フェーズ(fetch開始からレスポンス受信まで)にのみ適用する。
            // デコード・リサイズ(canvasでの再エンコード)にかかる時間は含めない。そのためAbortControllerと
            // タイマーはここ(sendFormData、fetch呼び出し直前)で張り、タイマー未設定のままclearTimeoutを
            // 呼んでしまうことがないようtimer変数もこの関数のスコープに閉じる
            function sendFormData(mainBlob, mainName, thumbBlob, thumbName) {
                var formData = new FormData();
                formData.append('file', mainBlob, mainName);
                if (thumbBlob) formData.append('thumb', thumbBlob, thumbName);
                tagIds.forEach(function(id) { formData.append('tagIds', id); });
                // albumIdは「投稿先アルバムのヒント」(#290)。空文字はbackend側で未指定扱いになるため、
                // 呼び出し元がnullを渡した場合(=カメラ以外の一括アップロード等、アルバムを明示選択
                // しない導線)もそのまま送ってよい
                if (albumId) formData.append('albumId', albumId);

                window.__jikuFetchControllers = window.__jikuFetchControllers || {};
                var controller = new AbortController();
                window.__jikuFetchControllers[requestId] = controller;
                var timer = setTimeout(function() { controller.abort(); }, timeoutMs);
                function cleanup() {
                    clearTimeout(timer);
                    delete window.__jikuFetchControllers[requestId];
                }

                fetch(url, {
                    method: 'POST',
                    headers: { 'Authorization': 'Bearer ' + authToken },
                    body: formData,
                    signal: controller.signal
                }).then(function(r) {
                    return r.text().then(function(t) {
                        cleanup();
                        if (!r.ok) { reject(new Error('HTTP ' + r.status + ': ' + t)); return; }
                        delete window.__jikuPendingFiles[pickId];
                        resolve('ok');
                    });
                }).catch(function(e) { cleanup(); reject(e); });
            }

            function decodeImageViaElement() {
                return new Promise(function(resolveImg, rejectImg) {
                    var element = new Image();
                    var objectUrl = URL.createObjectURL(file);
                    element.onload = function() { URL.revokeObjectURL(objectUrl); resolveImg(element); };
                    element.onerror = function() { URL.revokeObjectURL(objectUrl); rejectImg(new Error('image decode failed')); };
                    element.src = objectUrl;
                });
            }

            function decodeImage() {
                if (window.createImageBitmap) {
                    return createImageBitmap(file, { imageOrientation: 'from-image' }).catch(function() {
                        return decodeImageViaElement();
                    });
                }
                return decodeImageViaElement();
            }

            function resizedBlob(bitmap, maxDim, quality, mimeType) {
                return new Promise(function(resolveBlob) {
                    var srcW = bitmap.width;
                    var srcH = bitmap.height;
                    var scale = Math.min(1, maxDim / Math.max(srcW, srcH));
                    var targetW = Math.max(1, Math.round(srcW * scale));
                    var targetH = Math.max(1, Math.round(srcH * scale));
                    var canvas = document.createElement('canvas');
                    canvas.width = targetW;
                    canvas.height = targetH;
                    var ctx = canvas.getContext('2d');
                    ctx.drawImage(bitmap, 0, 0, targetW, targetH);
                    canvas.toBlob(function(blob) { resolveBlob(blob); }, mimeType, quality);
                });
            }

            // 元ファイルがimage/pngの場合、本体・サムネイルとも同じくimage/pngで書き出す(PNGのtoBlobは
            // quality引数を無視して常に可逆になる)。サムネイルだけJPEGにすると、透過スクリーンショット等の
            // サムネイルが黒潰れしてしまうため、本体・サムネイルは常に同じ形式にする。
            // PNG以外は従来どおりJPEGで再圧縮する
            var mimeType = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
            var extension = mimeType === 'image/png' ? '.png' : '.jpg';
            var baseName = file.name.replace(/\.[^.]+$/, '');

            decodeImage().then(function(bitmap) {
                Promise.all([
                    resizedBlob(bitmap, 2048, 0.85, mimeType),
                    resizedBlob(bitmap, 512, 0.8, mimeType)
                ]).then(function(results) {
                    if (bitmap.close) bitmap.close();
                    var reencodedMain = results[0];
                    var thumbBlob = results[1] || null;
                    var thumbName = 'thumb' + extension;
                    // 再エンコードした本体は、元ファイルより小さくなった場合だけ使う(小さい画像を
                    // 再エンコードすると、むしろファイルサイズが増えて無駄になることがあるため)。
                    // サムネイルは生成できていれば(本体を使うかに関わらず)添付する
                    var useReencoded = reencodedMain && reencodedMain.size < file.size;
                    var mainBlob = useReencoded ? reencodedMain : file;
                    // バックエンドはthumbに「512KB以下」かつ「本体パートより大きくない」ことを要求する
                    // (契約1。特にPNGサムネイルは膨らみやすい)。満たさないthumbを送るとアップロード
                    // 全体が400で失敗するため、ここで捨てる(thumb無しでも一覧は原寸フォールバックで表示できる)
                    if (thumbBlob && (thumbBlob.size > 512 * 1024 || thumbBlob.size > mainBlob.size)) {
                        thumbBlob = null;
                    }
                    if (useReencoded) {
                        sendFormData(mainBlob, baseName + extension, thumbBlob, thumbName);
                    } else {
                        sendFormData(file, file.name, thumbBlob, thumbName);
                    }
                }).catch(function() {
                    if (bitmap.close) bitmap.close();
                    sendFormData(file, file.name, null, null);
                });
            }).catch(function() {
                sendFormData(file, file.name, null, null);
            });
        }))
        ,
    'dev.rdd.jiku.closeViewfinderJs' : () => { if (window.__jikuCloseViewfinder) window.__jikuCloseViewfinder(); },
    'dev.rdd.jiku.pickAndUploadSingleImagePromise' : (url, authToken, method, requestId, timeoutMs) => 
        (new Promise(function(resolve, reject) {
            var input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/*';
            input.multiple = false;
            var changed = false;
            var settled = false;
            function finishCancelled() {
                if (settled) return;
                settled = true;
                resolve('false');
            }
            // 'cancel'イベント未対応のブラウザ向けに、ダイアログが閉じてwindowにフォーカスが
            // 戻ったタイミングでも(onchangeが発火していなければ)キャンセル扱いにするフォールバック
            input.oncancel = finishCancelled;
            window.addEventListener('focus', function onFocus() {
                window.removeEventListener('focus', onFocus);
                setTimeout(function() {
                    if (!changed && (input.files || []).length === 0) finishCancelled();
                }, 300);
            });
            input.onchange = function() {
                changed = true;
                var file = (input.files || [])[0];
                if (!file) { finishCancelled(); return; }
                settled = true;
                var formData = new FormData();
                formData.append('file', file);
                window.__jikuFetchControllers = window.__jikuFetchControllers || {};
                var controller = new AbortController();
                window.__jikuFetchControllers[requestId] = controller;
                var timer = setTimeout(function() { controller.abort(); }, timeoutMs);
                function cleanup() {
                    clearTimeout(timer);
                    delete window.__jikuFetchControllers[requestId];
                }
                fetch(url, {
                    method: method,
                    headers: { 'Authorization': 'Bearer ' + authToken },
                    body: formData,
                    signal: controller.signal
                }).then(function(r) {
                    return r.text().then(function(t) {
                        cleanup();
                        if (!r.ok) { reject(new Error('HTTP ' + r.status + ': ' + t)); return; }
                        resolve('true');
                    });
                }).catch(function(e) { cleanup(); reject(e); });
            };
            input.click();
        }))
        ,
    'dev.rdd.jiku.fetchBytesPromise' : (url, authToken, requestId, timeoutMs) => 
        (new Promise(function(resolve, reject) {
            window.__jikuFetchControllers = window.__jikuFetchControllers || {};
            var controller = new AbortController();
            window.__jikuFetchControllers[requestId] = controller;
            var timer = setTimeout(function() { controller.abort(); }, timeoutMs);
            function cleanup() {
                clearTimeout(timer);
                delete window.__jikuFetchControllers[requestId];
            }
            fetch(url, { headers: { 'Authorization': 'Bearer ' + authToken }, signal: controller.signal }).then(function(r) {
                if (!r.ok) {
                    return r.text().then(function(t) { throw new Error('HTTP ' + r.status + ': ' + t); });
                }
                return r.arrayBuffer();
            }).then(function(buf) {
                cleanup();
                resolve(buf);
            }).catch(function(e) {
                cleanup();
                reject(e);
            });
        }))
        ,
    'dev.rdd.jiku.shareLinkPromise' : (text) => 
        (new Promise(function(resolve) {
            if (navigator.share) {
                navigator.share({ text: text }).then(function() { resolve('shared'); }).catch(function() { resolve('shared'); });
            } else if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).then(function() { resolve('copied'); }).catch(function() { resolve('copied'); });
            } else {
                resolve('copied');
            }
        }))
        ,
    'dev.rdd.jiku.pickImagesForUploadPromise' : (maxCount) => 
        (new Promise(function(resolve) {
            window.__jikuPendingFiles = window.__jikuPendingFiles || {};
            window.__jikuNextPickId = window.__jikuNextPickId || 0;
            var input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/*';
            input.multiple = maxCount > 1;
            var changed = false;
            var resolved = false;
            function finish(value) {
                if (resolved) return;
                resolved = true;
                resolve(value);
            }
            // 'cancel'イベント未対応のブラウザ向けに、ダイアログが閉じてwindowにフォーカスが
            // 戻ったタイミングでも(onchangeが発火していなければ)キャンセル扱いにするフォールバック
            input.oncancel = function() { finish('{"files":[]}'); };
            window.addEventListener('focus', function onFocus() {
                window.removeEventListener('focus', onFocus);
                setTimeout(function() {
                    if (!changed && (input.files || []).length === 0) finish('{"files":[]}');
                }, 300);
            });
            input.onchange = function() {
                changed = true;
                var files = Array.prototype.slice.call(input.files || []);
                if (files.length === 0) { finish('{"files":[]}'); return; }
                // Issue #248: 上限を超えても選択自体は破棄せず、先頭maxCount枚だけを残して続行する
                // (tooManyFilesはtrueのまま返し、呼び出し元が「一部だけ選択しました」と通知できるようにする)
                var tooMany = files.length > maxCount;
                var limitedFiles = tooMany ? files.slice(0, maxCount) : files;
                var fileInfos = limitedFiles.map(function(file) {
                    var id = 'f' + (window.__jikuNextPickId++);
                    window.__jikuPendingFiles[id] = file;
                    return { pickId: id, name: file.name };
                });
                finish(JSON.stringify({ files: fileInfos, tooManyFiles: tooMany }));
            };
            input.click();
        }))
        ,
    'dev.rdd.jiku.inspectCustomReactionImagePromise' : (pickId) => 
        (new Promise(function(resolve, reject) {
            var file = window.__jikuPendingFiles ? window.__jikuPendingFiles[pickId] : null;
            if (!file) { reject(new Error('picked file not found: ' + pickId)); return; }
            var maxBytes = 512 * 1024;
            if (file.size <= maxBytes) {
                resolve(JSON.stringify({ eligible: true, sizeBytes: file.size }));
                return;
            }

            function decodeImageViaElement() {
                return new Promise(function(resolveImg, rejectImg) {
                    var element = new Image();
                    var objectUrl = URL.createObjectURL(file);
                    element.onload = function() { URL.revokeObjectURL(objectUrl); resolveImg(element); };
                    element.onerror = function() { URL.revokeObjectURL(objectUrl); rejectImg(new Error('image decode failed')); };
                    element.src = objectUrl;
                });
            }

            function decodeImage() {
                if (window.createImageBitmap) {
                    return createImageBitmap(file, { imageOrientation: 'from-image' }).catch(function() {
                        return decodeImageViaElement();
                    });
                }
                return decodeImageViaElement();
            }

            function makeSmallImage(bitmap) {
                var scale = Math.min(1, 512 / Math.max(bitmap.width, bitmap.height));
                var width = Math.max(1, Math.round(bitmap.width * scale));
                var height = Math.max(1, Math.round(bitmap.height * scale));
                var canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                canvas.getContext('2d').drawImage(bitmap, 0, 0, width, height);
                var baseName = file.name.replace(/\.[^.]+$/, '') || 'reaction';
                var firstMime = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
                function encode(mimeType, quality, fileName) {
                    return new Promise(function(resolveBlob, rejectBlob) {
                        canvas.toBlob(function(blob) {
                            if (!blob) { rejectBlob(new Error('image encode failed')); return; }
                            resolveBlob({ blob: blob, fileName: fileName });
                        }, mimeType, quality);
                    });
                }
                return encode(firstMime, 0.8, baseName + (firstMime === 'image/png' ? '.png' : '.jpg'))
                    .then(function(result) {
                        return result.blob.size <= maxBytes
                            ? result
                            : encode('image/jpeg', 0.7, baseName + '.jpg');
                    })
                    .then(function(result) {
                        if (result.blob.size > maxBytes) throw new Error('image is too large after resizing');
                        return result;
                    });
            }

            decodeImage().then(function(bitmap) {
                makeSmallImage(bitmap).then(function(result) {
                    if (bitmap.close) bitmap.close();
                    resolve(JSON.stringify({ eligible: true, sizeBytes: result.blob.size }));
                }).catch(function() {
                    if (bitmap.close) bitmap.close();
                    resolve('{"eligible":false}');
                });
            }).catch(function() { resolve('{"eligible":false}'); });
        }))
        ,
    'dev.rdd.jiku.uploadCustomReactionImagePromise' : (url, authToken, pickId, name, requestId, timeoutMs) => 
        (new Promise(function(resolve, reject) {
            var file = window.__jikuPendingFiles ? window.__jikuPendingFiles[pickId] : null;
            if (!file) { reject(new Error('picked file not found: ' + pickId)); return; }
            var maxBytes = 512 * 1024;

            function decodeImageViaElement() {
                return new Promise(function(resolveImg, rejectImg) {
                    var element = new Image();
                    var objectUrl = URL.createObjectURL(file);
                    element.onload = function() { URL.revokeObjectURL(objectUrl); resolveImg(element); };
                    element.onerror = function() { URL.revokeObjectURL(objectUrl); rejectImg(new Error('image decode failed')); };
                    element.src = objectUrl;
                });
            }

            function decodeImage() {
                if (window.createImageBitmap) {
                    return createImageBitmap(file, { imageOrientation: 'from-image' }).catch(function() {
                        return decodeImageViaElement();
                    });
                }
                return decodeImageViaElement();
            }

            function makeSmallImage(bitmap) {
                var scale = Math.min(1, 512 / Math.max(bitmap.width, bitmap.height));
                var width = Math.max(1, Math.round(bitmap.width * scale));
                var height = Math.max(1, Math.round(bitmap.height * scale));
                var canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                canvas.getContext('2d').drawImage(bitmap, 0, 0, width, height);
                var baseName = file.name.replace(/\.[^.]+$/, '') || 'reaction';
                var firstMime = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
                function encode(mimeType, quality, fileName) {
                    return new Promise(function(resolveBlob, rejectBlob) {
                        canvas.toBlob(function(blob) {
                            if (!blob) { rejectBlob(new Error('image encode failed')); return; }
                            resolveBlob({ blob: blob, fileName: fileName });
                        }, mimeType, quality);
                    });
                }
                return encode(firstMime, 0.8, baseName + (firstMime === 'image/png' ? '.png' : '.jpg'))
                    .then(function(result) {
                        // PNGを縮小しても大きい場合だけJPEGへ変換する。通常は透過を維持する。
                        return result.blob.size <= maxBytes
                            ? result
                            : encode('image/jpeg', 0.7, baseName + '.jpg');
                    })
                    .then(function(result) {
                        if (result.blob.size > maxBytes) throw new Error('image is too large after resizing');
                        return result;
                    });
            }

            function sendFormData(uploadFile, uploadFileName) {
                var formData = new FormData();
                formData.append('name', name);
                formData.append('file', uploadFile, uploadFileName);

                window.__jikuFetchControllers = window.__jikuFetchControllers || {};
                var controller = new AbortController();
                window.__jikuFetchControllers[requestId] = controller;
                var timer = setTimeout(function() { controller.abort(); }, timeoutMs);
                function cleanup() {
                    clearTimeout(timer);
                    delete window.__jikuFetchControllers[requestId];
                }

                fetch(url, {
                    method: 'POST',
                    headers: { 'Authorization': 'Bearer ' + authToken },
                    body: formData,
                    signal: controller.signal
                }).then(function(r) {
                    return r.text().then(function(t) {
                        cleanup();
                        if (!r.ok) { reject(new Error('HTTP ' + r.status + ': ' + t)); return; }
                        delete window.__jikuPendingFiles[pickId];
                        resolve('ok');
                    });
                }).catch(function(e) { cleanup(); reject(e); });
            }

            if (file.size <= maxBytes) {
                sendFormData(file, file.name);
                return;
            }
            decodeImage().then(function(bitmap) {
                makeSmallImage(bitmap).then(function(result) {
                    if (bitmap.close) bitmap.close();
                    sendFormData(result.blob, result.fileName);
                }).catch(function(error) {
                    if (bitmap.close) bitmap.close();
                    reject(new Error('custom-reaction-image-preparation-failed'));
                });
            }).catch(function(error) { reject(new Error('custom-reaction-image-preparation-failed')); });
        }))
        ,
    'dev.rdd.jiku.pushStatusJs' : () => 
        (function() {
            if (typeof Notification === 'undefined' || !('serviceWorker' in navigator) || !('PushManager' in window)) {
                return 'unsupported';
            }
            var isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
                (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
            var standalone = (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
                window.navigator.standalone === true;
            // iOSはホーム画面に追加していないと、許可しても通知が届かない
            if (isIos && !standalone) return 'needs-install';
            return Notification.permission;
        })()
        ,
    'dev.rdd.jiku.currentPushEndpointPromise' : () => 
        (function() {
            if (!('serviceWorker' in navigator)) return Promise.resolve('');
            return navigator.serviceWorker.ready
                .then(function(registration) { return registration.pushManager.getSubscription(); })
                .then(function(subscription) { return subscription ? subscription.endpoint : ''; })
                .catch(function() { return ''; });
        })()
        ,
    'dev.rdd.jiku.subscribePushPromise' : (vapidPublicKey) => 
        (function() {
            function toBytes(base64Url) {
                var padding = '='.repeat((4 - base64Url.length % 4) % 4);
                var base64 = (base64Url + padding).replace(/-/g, '+').replace(/_/g, '/');
                var raw = atob(base64);
                var bytes = new Uint8Array(raw.length);
                for (var i = 0; i < raw.length; i++) bytes[i] = raw.charCodeAt(i);
                return bytes;
            }
            return Notification.requestPermission().then(function(permission) {
                if (permission !== 'granted') return '';
                return navigator.serviceWorker.ready.then(function(registration) {
                    return registration.pushManager.getSubscription().then(function(existing) {
                        if (existing) return existing;
                        return registration.pushManager.subscribe({
                            // ブラウザの要求どおり、届いた通知は必ず表示する
                            userVisibleOnly: true,
                            applicationServerKey: toBytes(vapidPublicKey)
                        });
                    });
                }).then(function(subscription) {
                    return JSON.stringify(subscription.toJSON());
                });
            }).catch(function() { return ''; });
        })()
        ,
    'dev.rdd.jiku.unsubscribePushPromise' : () => 
        (function() {
            if (!('serviceWorker' in navigator)) return Promise.resolve('');
            return navigator.serviceWorker.ready
                .then(function(registration) { return registration.pushManager.getSubscription(); })
                .then(function(subscription) {
                    if (!subscription) return '';
                    var endpoint = subscription.endpoint;
                    return subscription.unsubscribe().then(function() { return endpoint; });
                })
                .catch(function() { return ''; });
        })()
        ,
    'dev.rdd.jiku.hideSplash' : () => { 
            (function() {
                var el = document.getElementById('jiku-splash');
                if (!el) return;
                el.classList.add('jiku-splash-hidden');
                el.addEventListener('transitionend', function onEnd() {
                    el.removeEventListener('transitionend', onEnd);
                    if (el.parentNode) el.parentNode.removeChild(el);
                });
            })()
             }
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    